import styled, { css } from 'styled-components';

export const Container = styled.div<{
  $removerMarginTop: boolean;
}>`
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => theme.spacing[6]}px 0;
  gap: ${({ theme }) => theme.spacing[5]}px;

  width: 100%;

  ${({ $removerMarginTop, theme }) => {
    if ($removerMarginTop) return '';
    return css`
      margin-top: ${theme.spacing[7]}px;
    `;
  }};
`;
